import { useEffect } from "react";
import { RxAvatar } from "react-icons/rx";

import { useGetArtistMeta } from "../api/queries";
// import AppState from "../store/appstate";
import useAppStore from "../store/appStateZustand";

function AccountAvatar() {
  // const selectedAccount = AppState.useState(s => s.selectedAccount);
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const artistMeta = useGetArtistMeta({ aac: selectedAccount });
  useEffect(() => {
    if (selectedAccount) {
      artistMeta.refetch();
    }
  }, [selectedAccount, artistMeta]);

  let imageUrl = null;

  if (artistMeta.isSuccess && artistMeta.data) {
    if (artistMeta.data.spotify_obj) {
      try {
        const obj = JSON.parse(artistMeta.data.spotify_obj);
        imageUrl = obj.images && obj.images[0] ? obj.images[0].url : null;
      }
      catch (error) {
        console.warn("[Avatar] Invalid JSON in spotify_obj:", artistMeta.data.spotify_obj, error);
      }
    }

    // if (!imageUrl && artistMeta.data.twitter_obj) {
    //   const tobj = JSON.parse(artistMeta.data.twitter_obj);

    //   imageUrl = tobj.data.profile_image_url;
    // }

    if (!imageUrl && artistMeta.data.bandsintown_obj) {
      try {
        const bobj = JSON.parse(artistMeta.data.bandsintown_obj);
        imageUrl = bobj.thumb_url;
      }
      catch (error) {
        console.warn("[Avatar] Invalid JSON in bandsintown_obj:", artistMeta.data.bandsintown_obj, error);
      }
    }

    // if (!imageUrl && artistMeta.data.facebook_obj) {
    //   const fobj = JSON.parse(artistMeta.data.facebook_obj);

    //   imageUrl = fobj?.picture?.data?.url;
    // }
  }

  return imageUrl ? (
    <div
      style={{
        backgroundImage: `url(${imageUrl})`,
        boxShadow: "inset 0 0 8px rgba(0, 0, 0, 0.3)",
      }}
      className="w-12 h-12 bg-center bg-cover rounded-full group-hover:grayscale"
      alt="profile avatar"
    />
  ) : (
    <div
      style={{
        boxShadow: "inset 0 0 2px rgba(0, 0, 0, 0.3)",
      }}
      className="flex justify-center w-12 h-12 text-black bg-gray-100 rounded-full"
    >
      <RxAvatar className="self-center" height={12} width={12} size={32} />
    </div>
  );
}

export default AccountAvatar;
